import { IDaySetting } from '../../../../../../../app/entities/DaySetting'
import { getActiveSchedulePattern } from '../../../../utils/schedule-patterns'
import { ITechnician } from '../../../../../../../app/entities/Technician'
import { ILocation } from '../../../../../../../app/entities/Location'

export function determineWorkingStatus(
  technician: ITechnician | undefined,
  selectedScheduleDate: number,
) {
  if (!technician) {
    return { isWorking: false, isDaySetting: false }
  }
  const { daySettings = [] } = technician

  const date = new Date(selectedScheduleDate)

  if (isNaN(date.getTime())) {
    return { isWorking: false, isDaySetting: false }
  }
  const [year, month, day] = date.toISOString().split('T')[0].split('-')

  const formattedDate = `${month}/${day}/${year.slice(-2)}`

  const daySetting = daySettings.find(
    (daySetting: IDaySetting) => daySetting.dayDate === formattedDate,
  )

  // Return working status based on daySetting, default to not working if no daySetting found
  return {
    isWorking: daySetting?.workDay ?? false,
    isDaySetting: !!daySetting,
  }
}

export function displayTechWorkHours(
  technician: ITechnician | undefined,
  location: ILocation | undefined,
  selectedScheduleDate: number,
) {
  if (!technician || !location) {
    return ''
  }
  // Note: technician here comes with schedulePatterns populated from backend
  const { daySettings = [], schedulePatterns = [] } = technician

  // Find day setting for the selected date
  const date = new Date(selectedScheduleDate)
  const [year, month, day] = date.toISOString().split('T')[0].split('-')
  const formattedDate = `${month}/${day}/${year.slice(-2)}`

  const daySetting = daySettings.find(
    (ds: IDaySetting) => ds.dayDate === formattedDate && ds.workDay,
  )

  // Find active schedule pattern (most recently created)
  const activeSchedulePattern = getActiveSchedulePattern(schedulePatterns)

  // Priority: day setting → schedule pattern → technician (deprecated) → location
  const startTime =
    daySetting?.startTime ||
    activeSchedulePattern?.workDayFrom ||
    technician.workDayFrom ||
    location.workDayFrom ||
    'N/A'

  const endTime =
    daySetting?.endTime ||
    activeSchedulePattern?.workDayTo ||
    technician.workDayTo ||
    location.workDayTo ||
    'N/A'

  return `${startTime} - ${endTime}`
}
